import { useEffect, useState, useContext, useRef } from "react";
import { SpikerBoardContext, SpikerBoardContextI } from "../context/SpikerBoardContext";
import { HTime, HTimeFormat } from "../lib/HDateTime";
import CategoryList from "./CategoryList";
import { Divider, ScrollPanel, Tag } from "primereact";
import axios from "axios";
import AppConfig from "../AppConfig";
import { HPersonResult, HResultStatus } from "../lib/HResult";

export default function ResultBox(props) {
    const [spikerBoardContext, setSpikerBoardContext] = useContext(SpikerBoardContext);
    const [categories, setCategories] = useState([]);
    const [results, setResults] = useState([]);
    const [activeResultCategory, setActiveResultCategory] = useState(0);
    const [resultCategoryHeader, setResultCategoryHeader] = useState("");
    const eventStartTime = useRef(null);
    const [timeNow, setTimeNow] = useState(new HTime());
    const c_calculateResults = useRef(false);
    const c_results = useRef([]);
    const c_classBestTime = useRef(new HTime());
    const c_refreshInterval = 10;
    const c_refreshIntervalCounter = useRef(10);

    useEffect(() => {
        setTimeout(() => {
            calculateResults();
            setTimeNow(new HTime());
            c_refreshIntervalCounter.current--;
            if (c_refreshIntervalCounter.current < 0) {
                c_refreshIntervalCounter.current = c_refreshInterval;
                LoadResults();
            }
        }, 1000);
    }, [timeNow]);

    useEffect(() => {
        LoadResults();
    }, [activeResultCategory]);
    const LoadResults = () => {
        //stop calculating
        c_calculateResults.current = false;
        //get start time
        eventStartTime.current = HTime.Parse(spikerBoardContext.eventSettings.starttime);

        let cHeader = spikerBoardContext.categories.find((el) => el.ID == activeResultCategory);
        console.log(cHeader);
        if (cHeader !== undefined) {
            setResultCategoryHeader(cHeader.Name);
        }
        //get results in category
        //filter_categoryId
        const headers = {
            'Content-Type': 'text/json; charset=UTF-8'
        }
        axios.get(AppConfig().Server.Hostname + "/results?eid=" + spikerBoardContext.event.ID + "&filter_categoryId=" + activeResultCategory, null, { headers }).then(
            (resp) => {
                parseResults(resp.data);
            }
        ).catch((err) => {
        });
    }
    const sortByResult = (a, b) => {
        //by status first

        //by result time
        if (a.result.time < b.result.time) return -1;
        if (a.result.time > b.result.time) return 1;
        //if time equal sort by starttime
        if (a.start.time < b.start.time) return -1;
        if (a.start.time > b.start.time) return 1;

        return 0;
        if (a.result.time < b.result.time) return -1;
    }
    const calculateResults = () => {
        if (!c_calculateResults.current) return;
        var tNow = new HTime();

        c_results.current.map((el) => {
            if (el.result.status != HResultStatus.RUN) return;
            if (tNow < el.start.realtime) {
                return;
            }
            var time = HTime.Diff(tNow, el.start.realtime);
            el.result.time = time;
            el.result.timeLoss = HTime.Diff(el.result.time, c_classBestTime.current);
        });
        c_results.current.sort(sortByResult);
        //console.log(r);
        setResults(c_results.current);
    }
    const parseResults = (d) => {
        var tmpBestTime = null;
        var tmpResults = [];
        var place = 1;
        d.map((r) => {
            let res = new ResultLineInterface();
            res.name = r.Person.Name;
            res.club = r.Person.Club;
            //start
            res.start.time = r.Person.StartTime;
            res.start.realtime = HTime.Add(eventStartTime.current, HTime.Parse(res.start.time));
            //result
            res.result.time = HTime.Parse(r.Result.Result);
            res.result.status = r.Result.Status;
            res.result.timeLoss = null;

            //finish
            if (r.Finish != null) {
                res.finish.realtime = r.Finish.Realtime;
            }
            //set best time
            if (res.result.status == HResultStatus.OK || res.result.status == HResultStatus.NOFF) {
                if (tmpBestTime == null) tmpBestTime = res.result.time;
                if (res.result.time < tmpBestTime) tmpBestTime = res.result.time;
                c_classBestTime.current = tmpBestTime;

                res.result.place = place;
                place++;
            }
            //==========
            tmpResults.push(res);
        });
        tmpResults.map((r) => {
            if (tmpBestTime == null) return;
            if (r.result.status == HResultStatus.OK || r.result.status == HResultStatus.NOFF) {
                r.result.timeLoss = HTime.Diff(r.result.time, c_classBestTime.current);
            }
        });
        c_results.current = tmpResults;
        c_calculateResults.current = true;
    }
    return (
        <>

            <div className="grid grid-cols-12 gap-2 h-full">
                <div className="col-span-2">
                    <CategoryList items={categories} onSetCategory={(id) => { setActiveResultCategory(id) }} />
                </div>
                <div className="col-span-10">
                    <div className="flex flex-col h-full ">
                        <div className="h-12 text-2xl">
                            Category: <span className="font-bold" >{resultCategoryHeader}</span>
                            <Divider />
                        </div>
                        <div className="flex-1 p-2">
                            <ResultLineHeader />
                            <ScrollPanel className="h-full w-full pb-10">
                                <div className="grid grid-cols-1 w-full pb-10 absolute ">
                                    {results.map((r) => {
                                        if ((r.result.status == HResultStatus.RUN && r.start.realtime < new HTime()) || (r.result.status == HResultStatus.RUN) || r.result.status == HResultStatus.OK || r.result.status == HResultStatus.NOFF)
                                            return (<ResultLine result={r} />)
                                    })
                                    }

                                    {results.map((r) => {
                                        let status = r.result.status;
                                        //show all not OK and RUN not started yes
                                        if ((status != HResultStatus.OK && status != HResultStatus.NOFF) /*|| (status == HResultStatus.RUN && r.start.realtime > new HTime())*/)
                                            return (<ResultLine result={r} />)
                                    })
                                    }
                                </div>
                            </ScrollPanel>
                        </div >
                    </div >
                </div>
            </div>

        </>
    )
}

class ResultLineInterface {
    start = class {
        realtime;
        time;
    }
    finish = class {
        realtime;
    }
    name;
    club;
    result = class {
        time;
        place;
        status;
        timeLoss;
    }
}

export function ResultLine(props) {
    var rStatus = props.result.result.status
    var rTime = props.result.result.time;
    var rTimeLoss = props.result.result.timeLoss;
    var rPlace = props.result.result.place;
    var sh_place = "";
    var sh_time = "";
    var sh_timeLoss = "";
    var sh_starttime = props.result.start.realtime;
    var sh_noff = "";
    var row_bg;
    var text_color = "text-black";
    var text_colors = {
        OK: "text-black",
        NOTOK: "text-black",
        RUN: "text-grey-900"
    }
    return (
        <>
            {(() => {
                if (rStatus == HResultStatus.DISQ) sh_place = "DISQ";
                if (rStatus == HResultStatus.DNF) sh_place = "DNF";
                if (rStatus == HResultStatus.DNS) sh_place = "DNS";
                if (rStatus == HResultStatus.RUN) sh_place = ">>>";
                if (rStatus == HResultStatus.OK || rStatus == HResultStatus.NOFF) sh_place = rPlace;
                //console.log(sh_place);
                if (rStatus != HResultStatus.OK && rStatus != HResultStatus.RUN && rStatus != HResultStatus.NOFF) {
                    sh_time = sh_place;
                    sh_timeLoss = "---";
                } else {
                    //console.log(rTimeLoss);
                    sh_time = rTime.ToString(HTimeFormat.HMS);
                    if (rTimeLoss != null) sh_timeLoss = "+" + rTimeLoss.ToString(HTimeFormat.MMS);
                }
                //set row color
                if (rStatus == HResultStatus.RUN) text_color = text_colors.RUN;
                //set noff bagde
                if (rStatus == HResultStatus.NOFF) sh_noff = (<Tag severity="warning" value="not offcial"></Tag>);
            })()}
            <div className={"grid grid-cols-12 border-b-2 p-1 " + text_color}>
                <div className="col-span-1 text-center  content-center ">
                    {sh_place}
                </div>
                <div className="col-span-1  content-center">
                    {sh_starttime.ToString(HTimeFormat.HMS)}
                </div>
                <div className="col-span-5 font-bold content-center">
                    {props.result.name}
                </div>
                <div className="col-span-4 content-center">
                    {props.result.club}
                </div>
                <div className="col-span-1 text-right grid grid-cols-1 h-full pr-5">
                    <div >
                        {sh_time}{sh_noff}
                    </div>
                    <div className="text-sm italic" >
                        {sh_timeLoss}
                    </div>
                </div>
            </div >
        </>
    )
}
export function ResultLineHeader() {
    return (
        <div className="grid grid-cols-12 border-b-2 w-full ">
            <div className="text-center col-span-1 font-bold">
                #
            </div>
            <div className="col-span-1 font-bold">
                Start
            </div>
            <div className="col-span-5 font-bold">
                Competitor
            </div>
            <div className="col-span-4 font-bold">
                Club
            </div>
            <div className=" col-span-1 text-right font-bold grid grid-cols-1 h-full">
                <div >
                    Time
                </div>
                <div className="text-sm italic" >
                    Loss
                </div>
            </div>
        </div>
    )
}